import {Component} from '@angular/core';

@Component({
  selector: 'app-calendar-icon',
  styles: `
    :host {
      height: 30px;
      width: 30px;
      display: inline-block;
      line-height: 0;
    }
  `,
  template: `
    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
      <path
        d="M26.3121 3.19731H24.2224V2.42169C24.2224 1.90384 23.803 1.48413 23.2851 1.48413C22.7673 1.48413 22.3479 1.90384 22.3479 2.42169V3.19731H15.9375V2.42169C15.9375 1.90384 15.518 1.48413 15.0002 1.48413C14.4824 1.48413 14.0629 1.90384 14.0629 2.42169V3.19731H7.65253V2.42169C7.65253 1.90384 7.2331 1.48413 6.71525 1.48413C6.19741 1.48413 5.77798 1.90384 5.77798 2.42169V3.19731H3.68829C1.97797 3.19731 0.586365 4.58891 0.586365 6.29952V25.4137C0.586365 27.1243 1.97797 28.5159 3.68829 28.5159H26.3121C28.0224 28.5159 29.414 27.1243 29.414 25.4137V6.29952C29.414 4.58891 28.0224 3.19731 26.3121 3.19731ZM3.68829 5.07242H5.77799V5.84833C5.77799 6.36618 6.19741 6.78589 6.71526 6.78589C7.23311 6.78589 7.65253 6.36618 7.65253 5.84833V5.07242H14.0629V5.84833C14.0629 6.36618 14.4824 6.78589 15.0002 6.78589C15.5181 6.78589 15.9375 6.36618 15.9375 5.84833V5.07242H22.3479V5.84833C22.3479 6.36618 22.7673 6.78589 23.2852 6.78589C23.803 6.78589 24.2224 6.36618 24.2224 5.84833V5.07242H26.3121C26.989 5.07242 27.5395 5.62288 27.5395 6.29952V9.45122H2.46091V6.29952C2.46091 5.62288 3.01137 5.07242 3.68829 5.07242ZM26.3121 26.6408H3.68829C3.01138 26.6408 2.46091 26.0904 2.46091 25.4137V11.3263H27.5395V25.4137C27.5395 26.0904 26.989 26.6408 26.3121 26.6408Z"
        fill="black"/>
      <path
        d="M9.08077 13.6855H6.33247C5.81463 13.6855 5.3952 14.1053 5.3952 14.6231C5.3952 15.141 5.81463 15.5607 6.33247 15.5607H9.08077C9.59862 15.5607 10.018 15.141 10.018 14.6231C10.018 14.1053 9.59862 13.6855 9.08077 13.6855Z"
        fill="black"/>
      <path
        d="M9.08077 18.1418H6.33247C5.81463 18.1418 5.3952 18.5616 5.3952 19.0794C5.3952 19.5972 5.81463 20.017 6.33247 20.017H9.08077C9.59862 20.017 10.018 19.5972 10.018 19.0794C10.018 18.5616 9.59862 18.1418 9.08077 18.1418Z"
        fill="black"/>
      <path
        d="M9.08077 22.5981H6.33247C5.81463 22.5981 5.3952 23.0179 5.3952 23.5357C5.3952 24.0535 5.81463 24.4733 6.33247 24.4733H9.08077C9.59862 24.4733 10.018 24.0535 10.018 23.5357C10.018 23.0179 9.59862 22.5981 9.08077 22.5981Z"
        fill="black"/>
      <path
        d="M16.3254 13.6855H13.5771C13.0593 13.6855 12.6398 14.1053 12.6398 14.6231C12.6398 15.141 13.0593 15.5607 13.5771 15.5607H16.3254C16.8432 15.5607 17.2627 15.141 17.2627 14.6231C17.2627 14.1053 16.8432 13.6855 16.3254 13.6855Z"
        fill="black"/>
      <path
        d="M16.3254 18.1418H13.5771C13.0593 18.1418 12.6398 18.5616 12.6398 19.0794C12.6398 19.5972 13.0593 20.017 13.5771 20.017H16.3254C16.8432 20.017 17.2627 19.5972 17.2627 19.0794C17.2627 18.5616 16.8432 18.1418 16.3254 18.1418Z"
        fill="black"/>
      <path
        d="M16.3254 22.5981H13.5771C13.0593 22.5981 12.6398 23.0179 12.6398 23.5357C12.6398 24.0535 13.0593 24.4733 13.5771 24.4733H16.3254C16.8432 24.4733 17.2627 24.0535 17.2627 23.5357C17.2627 23.0179 16.8432 22.5981 16.3254 22.5981Z"
        fill="black"/>
      <path
        d="M23.5707 13.6855H20.8224C20.3046 13.6855 19.8851 14.1053 19.8851 14.6231C19.8851 15.141 20.3046 15.5607 20.8224 15.5607H23.5707C24.0885 15.5607 24.508 15.141 24.508 14.6231C24.508 14.1053 24.0885 13.6855 23.5707 13.6855Z"
        fill="black"/>
      <path
        d="M23.5707 18.1418H20.8224C20.3046 18.1418 19.8851 18.5616 19.8851 19.0794C19.8851 19.5972 20.3046 20.017 20.8224 20.017H23.5707C24.0885 20.017 24.508 19.5972 24.508 19.0794C24.508 18.5616 24.0885 18.1418 23.5707 18.1418Z"
        fill="black"/>
      <path
        d="M23.5707 22.5981H20.8224C20.3046 22.5981 19.8851 23.0179 19.8851 23.5357C19.8851 24.0535 20.3046 24.4733 20.8224 24.4733H23.5707C24.0885 24.4733 24.508 24.0535 24.508 23.5357C24.508 23.0179 24.0885 22.5981 23.5707 22.5981Z"
        fill="black"/>
    </svg>
  `,
  standalone: true
})

export class CalendarIconComponent {

}
